import { render, staticRenderFns } from "./ScrapPrices.vue?vue&type=template&id=b50c3f60&"
import script from "./ScrapPrices.vue?vue&type=script&lang=js&"
export * from "./ScrapPrices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports